import { useTextInput } from '@hooks';
import { resetPassword } from '@libraries/firebase';
import { Button, FormError, FormRow, getLogInRoute, TextInput } from '@shared';
import { getRedirectPath } from '@utils';
import { useRouter } from 'next/router';
import { FormEvent, useState } from 'react';
import { ForgotPassword } from '../components/ForgotPassword';
import { AuthForm } from '../components/Form';
import { AuthHeading } from '../components/Heading';
import { IntroMessage } from '../components/IntroMessage';
import { EmailSentMessage } from './EmailSentMessage';

export function ResetForm() {
  const [emailSent, setEmailSent] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const email = useTextInput();
  const router = useRouter();
  const redirectTo = getRedirectPath(router);
  const logInRoute = getLogInRoute(redirectTo);

  function handleError(newEmailErr: string) {
    setLoading(() => false);
    email.updateError(newEmailErr);
  }

  function handleEmailSent() {
    setEmailSent(() => true);
    setLoading(() => false);
  }

  function handleReset(event?: FormEvent) {
    event?.preventDefault();

    email.updateError('');
    setLoading(() => true);
    resetPassword(email.value, handleError, handleEmailSent);
  }

  if (emailSent) {
    return <EmailSentMessage email={email.value} />;
  }

  return (
    <AuthForm onSubmit={handleReset}>
      <AuthHeading>Forgot your password?</AuthHeading>

      <IntroMessage>
        We all forget things sometimes. Enter your email address and we will
        help you reset your password
      </IntroMessage>

      <FormRow>
        <TextInput
          disabled={isLoading}
          hasError={!!email.error}
          placeholder="Email"
          onChange={email.updateValue}
          type="email"
          value={email.value}
        />
        <FormError msg={email.error} />
      </FormRow>

      <ForgotPassword
        href={logInRoute}
        text="Remember your password? Click here to log in instead."
      />

      <Button onClick={handleReset}>Reset password</Button>
    </AuthForm>
  );
}
